import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk'
import reducers from '../_reducers'

export default function configureStore() {
  return createStore(
    combineReducers({
      ...reducers
    }),
    {},
    compose(
      applyMiddleware(thunk)
    )
  );
}